import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import {OfficesTableComponent} from './offices-table/offices-table.component';

@Component({
  selector: 'app-offices',
  templateUrl: './offices.component.html',
  styleUrls: ['./offices.component.css']
})
export class OfficesComponent implements OnInit {

  constructor(private appComponent: AppComponent) { }

  ngOnInit(): void {
    
  }

}
